<template>
  <SelectMultipleInput
    v-model="model"
    :items="items"
    item-text="itemText"
    item-value="companyCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'CompanyMultipleInput',

  mixins: [APIUtils, Message],

  components: {
    SelectMultipleInput,
  },

  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
    companyCat: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0002')
      },
    },
  },

  async mounted() {
    this.loading = true
    try {
      let params = {}
      if (this.validOnly) {
        params.validOnly = true
      }
      if (this.companyCat) {
        params.companyCatCd = this.companyCat
      }

      this.items = []
      const elements = await API.get('/master/companies', params)
      elements.forEach((element) => {
        element['itemText'] = `${element['companyCd']}: ${element['companyName']}`
        this.items.push(element)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0005') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
